const logoEvents = new EventTarget();

export const emitChange = (logo: string | null) => {
  logoEvents.dispatchEvent(new CustomEvent('logoChange', { detail: logo }));
};

export const onChange = (callback: (logo: string | null) => void) => {
  const handler = (e: Event) => {
    const event = e as CustomEvent<string | null>;
    callback(event.detail);
  };
  logoEvents.addEventListener('logoChange', handler);
  return () => logoEvents.removeEventListener('logoChange', handler);
};